import React, { useEffect, useState } from "react";

const ACTION_TYPES = [
  { value: "auction",         label: "Auction",          hint: "Bidding with a winner" },
  { value: "raffle",          label: "Raffle",           hint: "Free or paid entries, random winner" },
  { value: "challenge",       label: "Challenge",        hint: "Hashtag-driven submissions" },
  { value: "contest",         label: "Contest",          hint: "Entry-based competition" },
  { value: "ama",             label: "AMA",              hint: "Ask Me Anything Q&A" },
  { value: "ugc_campaign",    label: "UGC Campaign",     hint: "User-generated content drive" },
  { value: "themed_day",      label: "Themed Day",       hint: "Themed social posts" },
  { value: "collab_takeover", label: "Collab / Takeover", hint: "Partner collaboration" },
  { value: "poll_quiz",       label: "Poll / Quiz",      hint: "Polls or quiz questions" },
];

const defaultPostName = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `Post ${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export default function ActionTypePicker({
  isOpen,
  onClose,
  onConfirm,
  initialName,
  title = "Add an action",
}) {
  const [name, setName] = useState("");
  const [type, setType] = useState("");

  useEffect(() => {
    if (isOpen) {
      setName((initialName && initialName.trim()) || defaultPostName());
      setType("");
    }
  }, [isOpen, initialName]);

  if (!isOpen) return null;

  const canConfirm = !!type && name.trim().length > 0;

  return (
    <div
      className="modal block"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      style={{
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        inset: 0,
        zIndex: 1060,
        padding: "1rem",
        overflow: "auto",
      }}
      onClick={onClose}
    >
      <div
        className="modal-dialog"
        style={{ margin: 0, maxWidth: 560, width: "100%" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div
            className="modal-header"
            style={{ justifyContent: "center", position: "relative" }}
          >
            <h5
              className="modal-title"
              style={{ color: "#253866", textAlign: "center", width: "100%" }}
            >
              {title}
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onClose}
              style={{ position: "absolute", right: "1rem" }}
            />
          </div>

          <div className="modal-body" style={{ padding: "1rem" }}>
            <div className="form-group" style={{ marginBottom: "1rem" }}>
              <label htmlFor="actionPickerName" style={{ display: "block", marginBottom: 4 }}>
                Post name
              </label>
              <input
                id="actionPickerName"
                type="text"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={defaultPostName()}
                maxLength={120}
                style={{ width: "100%" }}
              />
              <small style={{ color: "#6c757d" }}>
                Shown as the title on the action's public page.
              </small>
            </div>

            <div className="form-group">
              <label style={{ display: "block", marginBottom: 4 }}>Action type</label>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
                  gap: "0.5rem",
                }}
              >
                {ACTION_TYPES.map((a) => {
                  const selected = type === a.value;
                  return (
                    <button
                      key={a.value}
                      type="button"
                      onClick={() => setType(a.value)}
                      aria-pressed={selected}
                      style={{
                        textAlign: "left",
                        padding: "0.6rem 0.75rem",
                        borderRadius: 8,
                        border: selected ? "2px solid #253866" : "1px solid #d0d4dc",
                        background: selected ? "#eef1f8" : "#fff",
                        color: "#253866",
                        cursor: "pointer",
                        minHeight: 64,
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        outline: "none",
                      }}
                    >
                      <span style={{ fontWeight: 600 }}>{a.label}</span>
                      <span style={{ fontSize: 12, color: "#6c757d", lineHeight: 1.2 }}>
                        {a.hint}
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>

          <div
            className="modal-footer"
            style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem", padding: "0.75rem 1rem" }}
          >
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              disabled={!canConfirm}
              onClick={() => onConfirm({ type, name: name.trim() })}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export { ACTION_TYPES };
